import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-slides",
  "use": "google-slides-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"google-slides\"><g clip-path=\"url(#google-slides_clip0_2_66)\"><rect width=\"16\" height=\"16\" rx=\"2\" fill=\"#F2B329\" /><path d=\"M2 4.5h12v7H2v-7z\" fill=\"#fff\" /></g><defs><clipPath id=\"google-slides_clip0_2_66\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol